import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getSearchOrders,
  getCustomerAlerts,
  setShowEmptyState,
  setLoading,
  resetState,
  setSearchType,
  setSearchValue,
} from '../../store/orders/actions';
import { SearchOrderV1Comp } from '../../components/widgets/SearchOrder/SearchOrderV1Comp';

const SearchOrder = (props) => <SearchOrderV1Comp {...props} />;

export default withRouter(
  connect(
    (state, ownProps) => {
      const { ordersState } = state;

      const { searchType, searchValue, isNewUI } = ordersState;
      return {
        ownProps,
        searchType,
        searchValue,
        ordersState,
        isNewUI,
      };
    },
    (dispatch) => {
      return {
        getSearchOrders: (data) => dispatch(getSearchOrders(data)),
        getCustomerAlerts: (data) => dispatch(getCustomerAlerts(data)),
        setShowEmptyState: (isShowEmptyState) =>
          dispatch(setShowEmptyState(isShowEmptyState)),
        setLoading: (isLoading) => dispatch(setLoading(isLoading)),
        resetState: (isReset) => dispatch(resetState(isReset)),
        setSearchType: (value) => dispatch(setSearchType(value)),
        setSearchValue: (value) => dispatch(setSearchValue(value)),
      };
    },
  )(SearchOrder),
);
